export function hasDirectLink(hotel) {
	return !!hotel.direct_link;
}
